import React from 'react';
import PropTypes from 'prop-types';

// import CONFIG from '../../../config/config';
import FieldGroupComponent from '../../core/FieldGroupComponent/FieldGroupComponent'
import LoadingComponent from '../../core/LoadingComponent/LoadingComponent';

import { Button, Form } from 'react-bootstrap';

import './update-profile.scss';

class UpdateInfoComponent extends React.Component {
    render() {
        const { handleSubmit, submitting, invalid } = this.props;
        return <div>
            {submitting && <LoadingComponent fullScreen />}
            <Form onSubmit={handleSubmit}>
                <FieldGroupComponent
                    label="First Name"
                    name="firstName"
                    type="text"
                    formProps={{
                        maxLength: 30,
                    }}
                />
                <FieldGroupComponent
                    label="Last Name"
                    name="lastName"
                    type="text"
                    formProps={{
                        maxLength: 30,
                    }}
                />
                <Button type='submit' disabled={invalid} className="tertiary">Update</Button>
            </Form>
        </div>;
    }
}

UpdateInfoComponent.propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    submitting: PropTypes.bool,
    invalid: PropTypes.bool.isRequired,
};

export default UpdateInfoComponent;



// WEBPACK FOOTER //
// ./src/components/profile/Profile/UpdateInfoComponent.js